import Cookie from 'js-cookie'

/**
 * 跳转到客服页面的全局方法
 * @param {string|number} shopId - 商家ID
 * @param {Object} options - 可选参数
 */
function goToCustomerService (shopId, options = {}) {
  if (!Cookie.get('token')) {
    this.$store.commit('SHOW_LOGIN')
    return
  }
    // 验证商家ID
    if (!shopId) {
      console.warn('商家ID不能为空')
      return
    }

    // 构造跳转路径
    const routeData = {
      path: '/customerService', // 客服页面路径
      query: {
        shopId: shopId,
        ...options // 其他可选参数，如商品ID、订单ID等
      }
    }

    // 如果在Vue实例中可以直接使用$router
    if (this && this.$router) {
      this.$router.push(routeData)
    } else {
      // 如果不在Vue实例中，需要通过其他方式获取router实例
      // 这种情况下你可能需要导入router实例
      import('@/router').then(routerModule => {
        const router = routerModule.default
        router.push(routeData)
      })
    }
  }

  // 将方法挂载到Vue原型上，使其成为全局方法
  export default goToCustomerService



// WEBPACK FOOTER //
// ./src/util/customerService.js